import React, { useMemo } from "react";

const COLORS = ["#FFE600", "#FF007F", "#00F0FF", "#39FF14", "#9D00FF", "#FF9500"];

export const StageUnlockBurst = ({ fx }) => {
  const particles = useMemo(() => Array.from({ length: 90 }, (_, i) => {
    const angle = Math.random() * Math.PI * 2;
    const dist = 160 + Math.random() * 420;
    return {
      id: i,
      dx: Math.cos(angle) * dist,
      dy: Math.sin(angle) * dist * 0.7 - 120,
      size: 5 + Math.random() * 8,
      color: COLORS[i % COLORS.length],
      rot: Math.random() * 720 - 360,
      delay: Math.random() * 0.15,
      round: Math.random() < 0.4,
    };
  }), [fx?.key]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!fx) return null;
  return (
    <div key={fx.key} data-testid="stage-unlock-burst" className="fixed inset-0 z-[9998] pointer-events-none overflow-hidden">
      <div className="absolute inset-0 stage-unlock-flash" />
      <div className="absolute left-1/2 top-1/2">
        {particles.map(p => (
          <span key={p.id} className="absolute stage-unlock-conf"
            style={{
              width: p.size, height: p.round ? p.size : p.size * 1.6,
              background: p.color, borderRadius: p.round ? "50%" : 2,
              boxShadow: `0 0 8px ${p.color}AA`, animationDelay: `${p.delay}s`,
              "--dx": `${p.dx}px`, "--dy": `${p.dy}px`, "--rot": `${p.rot}deg`,
            }} />
        ))}
      </div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="stage-unlock-caption text-center font-heading uppercase">
          <div data-testid="stage-unlock-caption" className="text-4xl sm:text-5xl lg:text-6xl tracking-widest"
               style={{ color: "#FFE600", textShadow: "0 0 14px #FFE600, 0 0 34px #FF007F" }}>
            {fx.title}
          </div>
          <div className="mt-2 text-xs sm:text-sm tracking-[0.3em] neon-cyan">Advance when ready</div>
        </div>
      </div>
    </div>
  );
};
